import React from 'react'
import ContentSection from '../../../components/ContentSection'

export default function Introduction({ introduction }) {
  return (
    <div>
      <b>Introduction</b>
      <ContentSection content={introduction} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/AssessmentPlan/Introduction.js